{
  "LABEL_MGMT": {
    "HEADER": "Cimkék",
    "HEADER_BTN_TXT": "Cimke hozzáadása",
    "LOADING": "Cimkék letöltése",
    "DESCRIPTION": "A címkékkel kategorizálhatja és rangsorolhatja a beszélgetéseket és az érdeklődőket. Az oldalpanelen címkét rendelhet egy beszélgetéshez vagy kapcsolathoz.",
    "LEARN_MORE": "További információ a címkékről",
    "SEARCH_404": "Nincs megfelelő elem",
    "LIST": {
      "404": "Nincs megfelelő cimke ebben a fiókban.",
      "TITLE": "Cimkék kezelése",
      "DESC": "A cimkék a beszélgetések csoportokba rendezését segítik.",
      "TABLE_HEADER": {
        "NAME": "Név",
        "DESCRIPTION": "Leírás",
        "COLOR": "Szín"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Cimke neve",
        "PLACEHOLDER": "Cimke neve",
        "REQUIRED_ERROR": "A cimke nevének megadása kötelező",
        "MINIMUM_LENGTH_ERROR": "Minimum 2 karakter hosszúnak kell lennie",
        "VALID_ERROR": "Kizárólag betűk, számok, kötőjel és alulvonás szerepelhet"
      },
      "DESCRIPTION": {
        "LABEL": "Leírás",
        "PLACEHOLDER": "Cimke leírás"
      },
      "COLOR": {
        "LABEL": "Szín"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Cimke megjelenítése az oldalsávban"
      },
      "EDIT": "Szerkesztés",
      "CREATE": "Létrehozás",
      "DELETE": "Törlés",
      "CANCEL": "Mégse"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Címke hozzáadása a beszélgetéshez",
        "MULTIPLE_SUGGESTION": "Válassza ki ezt a címkét",
        "DESELECT": "Címke kijelölésének megszüntetése",
        "DISMISS": "Javaslatok kihagyása"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Elutasítás",
      "ADD_SELECTED_LABELS": "Kijelölt címkék hozzáadása",
      "ADD_SELECTED_LABEL": "Kijelölt címke hozzáadása",
      "ADD_ALL_LABELS": "Minden címke hozzáadása",
      "SUGGESTED_LABELS": "Javasolt címkék"
    },
    "ADD": {
      "TITLE": "Cimke hozzáadása",
      "DESC": "A cimkék a beszélgetések csoportokba rendezését segítik.",
      "API": {
        "SUCCESS_MESSAGE": "Cimke sikeresen hozzáadva",
        "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
      }
    },
    "EDIT": {
      "TITLE": "Cimke szerkesztése",
      "API": {
        "SUCCESS_MESSAGE": "Cimke sikeresen frissítve",
        "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "Cimke sikeresen törölve",
        "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra",
        "IN_USE_ERROR": "Ez a címke nem törölhető, mert a következők használják: {usages}. Először távolítsa el onnan.",
        "IN_USE_FILTERS": "szűrők: {names}",
        "IN_USE_AUTOMATIONS": "automatizálási szabályok: {names}",
        "IN_USE_MACROS": "makrók: {names}"
      },
      "CONFIRM": {
        "TITLE": "Törlés Megerősítése",
        "MESSAGE": "Biztos abban, hogy törli ",
        "YES": "Igen, Törlés ",
        "NO": "Nem, Mégse "
      }
    }
  }
}
